module.exports = __webpack_public_path__ + "img/px-recent-works.14eee523.png";